module.exports = __webpack_public_path__ + "img/407.6789b3a1.png";